
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import VueI18n from 'vue-i18n';
import TranslateResult = VueI18n.TranslateResult;
import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';


@Component(
  {
    name: 'catalog-product-configuration',
    components: ServiceContainer().getComponents()
  }
)

export default class extends Vue {
  @Prop() private readonly productData: object;
  @Prop({default: () => []}) private wishlistItems: Array<object>;
  @Prop({default: () => []}) private stockData: Array<object>;

  private expandDescription: boolean = false;

  private get storeStockCount(): Number {
    return this.stockData.filter((stock) => stock['quantity'] > 0).length;
  }

  private created(): void {
    this.$store.dispatch('CatalogProduct/getProductData', this.productData);
    SolarDataLayer.init().addViewItem(this.productData);
  }

  private get hasOverflow() {
    const description = this.$refs.description as HTMLElement;
    if(!description){
      return false;
    }
    return description?.clientHeight >= 100;
  }

  private toggleDescription() {
    this.expandDescription = !this.expandDescription;
  }
}
